import { CircularProgress } from '@mui/material';
import { ComponentType } from 'react';
import { useAuth } from './AuthContext/AuthContext';

interface AuthenticationGuardProps {
  component: ComponentType;
}

export function AuthenticationGuard({ component }: AuthenticationGuardProps) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth();
  const Component = component;

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  if (!isAuthenticated) {
    void loginWithRedirect({ appState: { returnTo: window.location.pathname } });
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  return <Component />;
}

export default AuthenticationGuard;
